// Placeholder origin a path is resolved against to see where it would lead.
const internalOrigin = 'https://internal.invalid';

/**
 * Whether a user-controlled path is app-internal and safe to navigate to,
 * guarding against open redirects. The path is resolved the way the browser
 * would, so absolute URLs, protocol-relative (`//host`) and backslash forms,
 * and ones the URL parser turns into those (e.g. `/<tab>/host`, as it strips
 * tabs and newlines) are not.
 */
export function isInternalPath(path: string | null | undefined): path is string {
  if (!path || !path.startsWith('/')) return false;
  try {
    return new URL(path, internalOrigin).origin === internalOrigin;
  } catch {
    return false;
  }
}

/**
 * Restricts a returnUrl to an app-internal path before navigating, falling
 * back to the home route (see `isInternalPath`).
 */
export function toInternalPath(returnUrl: string | null | undefined): string {
  return isInternalPath(returnUrl) ? returnUrl : '/';
}